import {
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_OPENED,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION,

  //
  WORKFLOW_ACTIVITY_ANY_MESSAGE,
  WORKFLOW_ACTIVITY_LAST_5_MESSAGES
} from 'Constants/'
import useSelectHelpers from 'Hooks/useSelectHelpers'
import { FormElement, Select } from 'mailup-web-components'
import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const activityTypesWithFixedMsgOptions = [
  WORKFLOW_ACTIVITY_ACTION_OPENED,
  WORKFLOW_ACTIVITY_ACTION_CLICKED,
  WORKFLOW_ACTIVITY_ACTION_ONE_ACTION,
  WORKFLOW_ACTIVITY_ACTION_TEN_ACTION
]

const InputEmailMessage = () => {
  const intl = useIntl()

  const { emailMessages } = useRecoilValue(workflowCommonDataState)
  const { IdMessage, ActivityType } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const [emailMessageIsDirty, setEmailMessageIsDirty] = useState(false)

  const emailMessageProps = useSelectHelpers(
    IdMessage,
    emailMessages,
    true,
    emailMessageIsDirty
  )

  const emailMessagesOptions = useMemo(() => {
    return activityTypesWithFixedMsgOptions.includes(ActivityType)
      ? [
          {
            value: WORKFLOW_ACTIVITY_ANY_MESSAGE,
            label: intl.formatMessage({
              id: 'Load.AutomationWorkflow.ActivitySettingsAnyLabel'
            })
          },
          {
            value: WORKFLOW_ACTIVITY_LAST_5_MESSAGES,
            label: intl.formatMessage({
              id: 'Load.AutomationWorkflow.ActivitySettingsLatestFiveSentLabel'
            })
          },

          ...emailMessages
        ]
      : emailMessages
  }, [ActivityType, emailMessages])

  const handleEmailMessageChange = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdMessage: value,
      ClickedLink: undefined
    }))
    setEmailMessageIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.ActivityMessageLabel'
      })}
      required
      feedback={
        emailMessageIsDirty && !IdMessage ? requiredFeedback : undefined
      }
      variant={emailMessageIsDirty && !IdMessage ? 'danger' : undefined}
    >
      <Select
        value={IdMessage}
        options={emailMessagesOptions}
        onChange={handleEmailMessageChange}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.ActivityMessagePlaceholder'
        })}
        {...emailMessageProps}
      />
    </FormElement>
  )
}

export default InputEmailMessage
